export function ajouterMois(date, mois) {
    const resultat = new Date(date);
    resultat.setUTCDate(1);
    resultat.setUTCMonth(resultat.getUTCMonth() + mois);
    const dernierJour = new Date(Date.UTC(resultat.getUTCFullYear(), resultat.getUTCMonth() + 1, 0)).getUTCDate();
    resultat.setUTCDate(Math.min(date.getUTCDate(), dernierJour));
    return resultat;
}
/** L'offre prime ; à priorité égale, la dernière exposition commencée gagne. */
export function attribuerVente(vente, expositions, mois) {
    const candidates = expositions.filter((e) => vente.date.getTime() < ajouterMois(e.finLe, mois).getTime() + 86_400_000 &&
        (vente.expositionsOffre.includes(e.id) ||
            (e.debutLe <= vente.date && e.oeuvres.includes(vente.oeuvreId))));
    candidates.sort((a, b) => Number(vente.expositionsOffre.includes(b.id)) -
        Number(vente.expositionsOffre.includes(a.id)) ||
        b.debutLe.getTime() - a.debutLe.getTime() ||
        a.id.localeCompare(b.id));
    return candidates[0]?.id ?? null;
}
export function formatOeuvre(oeuvre) {
    if (oeuvre.type === 'edition')
        return { format: 'edition', surfaceM2: null };
    const d = oeuvre.dimensions;
    if (!d)
        return { format: 'inconnu', surfaceM2: null };
    let surfaceM2 = (d.hauteur * d.largeur) / 10_000;
    if ((d.diametre ?? 0) > 0)
        surfaceM2 = Math.PI * (d.diametre / 200) ** 2;
    if (surfaceM2 <= 0)
        return { format: 'inconnu', surfaceM2: null };
    let format = 'plus_2';
    if (surfaceM2 < 0.25)
        format = 'moins_025';
    else if (surfaceM2 <= 1)
        format = '025_1';
    else if (surfaceM2 <= 2)
        format = '1_2';
    return { format, surfaceM2: (d.profondeur ?? 0) > 0 ? null : surfaceM2 };
}
export function mediane(valeurs) {
    if (!valeurs.length)
        return null;
    const triees = [...valeurs].sort((a, b) => a - b);
    const milieu = Math.floor(triees.length / 2);
    return triees.length % 2 ? triees[milieu] : (triees[milieu - 1] + triees[milieu]) / 2;
}
export function agregerCote(ventes, axe) {
    const groupes = new Map();
    for (const vente of ventes) {
        const valeur = String(vente[axe]);
        const cle = JSON.stringify([valeur, vente.devise]);
        const groupe = groupes.get(cle) ?? { valeur, devise: vente.devise, ventes: [] };
        groupe.ventes.push(vente);
        groupes.set(cle, groupe);
    }
    return [...groupes.values()]
        .map(({ valeur, devise, ventes: lignes }) => {
        const remises = lignes.flatMap((v) => (v.remisePdb === null ? [] : [v.remisePdb]));
        return {
            valeur,
            devise,
            nombre: lignes.length,
            prixMedianCentimes: mediane(lignes.map((v) => v.prixHtCentimes)),
            prixMedianM2Centimes: mediane(lignes.flatMap((v) => (v.surfaceM2 === null ? [] : [v.prixHtCentimes / v.surfaceM2]))),
            remiseMoyennePdb: remises.length
                ? remises.reduce((s, r) => s + r, 0) / remises.length
                : null,
        };
    })
        .sort((a, b) => a.valeur.localeCompare(b.valeur) || a.devise.localeCompare(b.devise));
}
export function etatDormance(oeuvre, mois, maintenant) {
    const derniereActiviteLe = new Date(Math.max(oeuvre.creeLe.getTime(), ...oeuvre.dernieresDates.map((d) => d.getTime())));
    const dormante = oeuvre.statut === 'disponible' && derniereActiviteLe <= ajouterMois(maintenant, -mois);
    let decision = null;
    if (dormante) {
        if (oeuvre.contactsInteresses)
            decision = 'salle_privee';
        else if (!oeuvre.dejaExposee)
            decision = 'exposer';
        else if (oeuvre.offresRefusees)
            decision = 'revoir_prix';
        else if (!oeuvre.artisteRepresente)
            decision = 'rendre';
    }
    return { dormante, derniereActiviteLe, decision };
}
//# sourceMappingURL=calcul.js.map